import type { RigidBody } from "@dimforge/rapier3d-compat";
import type { Vec3 } from "./body";

/**
 * The Push tool: pushes away from the camera, mostly horizontally, at the
 * point you clicked. Scaling by mass gives every block the same speed
 * change, heavy or light.
 */
export function applyPush(
  body: Pick<RigidBody, "mass" | "applyImpulseAtPoint">,
  dir: Vec3,
  point: Vec3,
  speed: number,
): void {
  const y = dir.y * 0.3;
  const m = (body.mass() * speed) / Math.hypot(dir.x, y, dir.z);
  body.applyImpulseAtPoint(
    { x: dir.x * m, y: y * m, z: dir.z * m },
    { x: point.x, y: point.y, z: point.z },
    true,
  );
}
